window.$ = $;

const escapeHTML = function(unsafe)
{
    return String(unsafe ?? '')
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

// UWAGA: `$(...)` parsuje string jako HTML i wykonuje osadzone skrypty/handlery,
// więc treść komunikatu MUSI być escape'owana (idzie tu m.in. tekst błędów walidacji
// i flashy, czyli dane pochodzące pośrednio od użytkownika). `<br>` z połączonych
// błędów pola przechodzi, bo składane są dopiero po escapowaniu (ajax-form.js).
window.alert = function(message, type = 'danger') {
    let $toast = $(`
        <div class="toast align-items-center text-white bg-${escapeHTML(type)} border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-body d-flex" data-bs-dismiss="toast">
                <div class='me-2'>
                    ${escapeHTML(message)}
                </div>
                <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </div>
    `);
    $('.toast-container').prepend($toast);
    $toast.toast('show');
};

window.escapeHTML = escapeHTML;

// przenosi pojedyncze znaki z końca linijki na początek następnej
export function addNbsps(el) {
    $(el).find(":not(iframe):not(style):not(script)").add(el).contents().filter((i, n) => n.nodeType == 3).each(function () {
        var startWhitespace = /^\s/.test(this.nodeValue) ? ' ' : '';
        var endWhitespace = /\s$/.test(this.nodeValue) ? ' ' : '';
        this.nodeValue = startWhitespace + (' ' + this.nodeValue + ' ').replace(/(\s\w)\s+/g, "$1\xA0").trim() + endWhitespace;
    });
};

addNbsps('body');

// Bootstrap 5 nie dokłada pluginu jQuery `.tooltip` — wywołanie bez zabezpieczenia
// rzucało wyjątkiem i przerywało wykonanie kolejnych modułów w bundlu.
if (typeof $.fn.tooltip === 'function') {
    $('[data-bs-toggle="tooltip"]').tooltip();
}